import { useEffect, useState } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams } from "utils/misc";

export default function useTags(filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchTags() {
    setLoading(true);
    const { response, data } = await API.admin.fetchTagsList(token, filtersToQueryParams(filters));

    if (response.ok) {
      setResult(data);
      setError(null);
    } else {
      setResult(null);
      setError(data?.message ?? null);
    }

    setLoading(false);
  }

  useEffect(() => {
    fetchTags();
  }, [token, Object.values(filters).join("__")]);

  return {
    loading,
    error,
    refresh: fetchTags,
    tags: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
